import { twMerge } from 'tailwind-merge';
import { CategoryTypeById, CategoryTypeString } from '@diritto/common/content/constants';
import { CircleRadioBoxIcon } from 'icons/CircleRadioBoxIcon';

export interface ProfileFavoriteCategoryItemProps {
  title: string;
  description: string;
  categoryIds: number[];
  checked?: boolean;
  onClick: () => void;
}

export const ProfileFavoriteCategoryItem = ({
  title,
  description,
  categoryIds,
  checked,
  onClick,
}: ProfileFavoriteCategoryItemProps) => (
  <div className="flex flex-col justify-center items-center w-[358px] cursor-pointer" onClick={onClick}>
    <div
      className={twMerge(
        'flex flex-row items-start justify-start rounded-md outline outline-1 outline-offset-[-1px] overflow-hidden h-[103px] w-full gap-4 p-4',
        checked ? 'bg-primary-100 outline-primary-500' : 'bg-white outline-black/10',
      )}>
      <div className="flex items-center justify-center h-full">
        <CircleRadioBoxIcon checked={checked} className="w-5 h-5" />
      </div>
      <div className="flex flex-col gap-1">
        <p className="text-black text-xs font-bold"> {title}</p>
        <p className="text-gray-1000 text-xxs font-regular">{description}</p>
        <p className="text-gray-600 text-xxxs font-regular">
          {categoryIds.map(categoryId => CategoryTypeString[CategoryTypeById[categoryId]]).join(', ')}
        </p>
      </div>
    </div>
  </div>
);
